import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "../api/ApiClient";

export interface MrrDataPoint {
  month: string;
  mrr: number;
}

export function useMrr() {
  const { getToken } = useAuth();
  const api = createApiClient(getToken);

  return useQuery({
    queryKey: ["dashboard-charts-mrr"],
    queryFn: () => api.get<MrrDataPoint[]>("/vendors/dashboard/charts/mrr"),
  });
}
